var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29395 5.928L13.357 0H12.157L7.76195 5.147L4.24995 0H0.199951L5.50995 7.784L0.199951 14H1.39995L6.04195 8.564L9.75095 14H13.801L8.29395 5.928ZM6.65095 7.852L6.11295 7.077L1.83195 0.91H3.67495L7.12895 5.887L7.66695 6.662L12.158 13.132H10.315L6.65095 7.852Z",
    fill: "#F6AF3E",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.856644610083799ecb8aa7fc2ef8fbd3.svg";
export { ForwardRef as ReactComponent };